module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/playerQuotes/rob_red-35db2efa72d909d06a77b96acbe09b6b.svg";